import { IActionItem } from '@components/ActionsMenu/types';

export const joinMenuSections = (sections: IActionItem[][]): IActionItem[] =>
  sections
    .filter((section) => section.length > 0)
    .flatMap((section, index) =>
      index === 0
        ? section
        : [{ ...section[0], divider: true }, ...section.slice(1)],
    );
